const createTree = ({ staticData, dynamicData }) => {
    const newData = staticData.map((item, index) => {
        if (item.children) {
            return { ...item, children: item.children.concat(dynamicData) };
        }
        return item;
    });

    return newData;
};

export default createTree;
